import { render, staticRenderFns } from "./start-animate.vue?vue&type=template&id=7d08ab6f&scoped=true&"
import script from "./start-animate.vue?vue&type=script&lang=js&"
export * from "./start-animate.vue?vue&type=script&lang=js&"
import style0 from "./start-animate.vue?vue&type=style&index=0&id=7d08ab6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08ab6f",
  null
  
)

export default component.exports